import SectionBody from '../components/SectionBody';
import SectionContainer from '../components/SectionContainer';
import SectionTitle from '../components/SectionTitle';

export default function Photos() {
  return (
    <SectionContainer containerId={'photos'}>
      <SectionTitle title={'photos'} />
      <SectionBody>
        <p className='section-text z-[11]'>
          To view our wedding photos, you can visit{' '}
          <a
            className='text-blue-400 hover:underline'
            target='_blank'
            rel='noreferrer'
            href='https://peterloguephotography.pixieset.com/robbieandloren/'
          >
            Peter Logue's website
          </a>
          . When prompted for a download code, enter <b>8566</b>.
        </p>
        <div />
      </SectionBody>
    </SectionContainer>
  );
}
